import { useState } from 'react'
import { Autocomplete, TextField, Stack, type TextFieldProps } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { cercaComuni, type Comune } from './comuni.api'

export interface Indirizzo {
  comune: string
  provincia: string
  indirizzo: string
}

interface Props {
  etichetta: string
  valore: Indirizzo
  onChange: (v: Indirizzo) => void
}

export function CampoIndirizzo({ etichetta, valore, onChange }: Props) {
  const [testo, setTesto] = useState('')
  const { data: opzioni = [] } = useQuery({
    queryKey: ['comuni', testo],
    queryFn: () => cercaComuni(testo),
    enabled: testo.trim().length >= 2,
  })

  return (
    <fieldset style={{ border: 0, padding: 0, margin: 0, minInlineSize: 0 }}>
      <legend>{etichetta}</legend>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <Autocomplete
          sx={{ flex: 2 }}
          options={opzioni}
          getOptionLabel={(o: Comune) => o.nome}
          // Cinque nomi si ripetono in province diverse: nell'elenco la sigla
          // li distingue, nel campo resta il solo nome.
          renderOption={(p, o: Comune) => (
            <li {...p} key={`${o.nome}|${o.provincia}`}>
              {o.nome} ({o.provincia})
            </li>
          )}
          isOptionEqualToValue={(a, b) => a.nome === b.nome && a.provincia === b.provincia}
          filterOptions={(x) => x}
          onInputChange={(_e, v) => setTesto(v)}
          onChange={(_e, c) => c && onChange({ ...valore, comune: c.nome, provincia: c.provincia })}
          // I params di renderInput sono coerenti con TextField, ma li tipizza con
          // proprieta opzionali = undefined che exactOptionalPropertyTypes rifiuta.
          renderInput={(p) => <TextField {...(p as TextFieldProps)} label="Comune" />}
        />
        <TextField
          sx={{ flex: 1 }}
          label="Provincia"
          value={valore.provincia}
          slotProps={{ input: { readOnly: true } }}
        />
        <TextField
          sx={{ flex: 3 }}
          label="Indirizzo"
          value={valore.indirizzo}
          onChange={(e) => onChange({ ...valore, indirizzo: e.target.value })}
        />
      </Stack>
    </fieldset>
  )
}
